import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { of, Subject } from 'rxjs';
import { map, mergeMap, takeUntil } from 'rxjs/operators';
import { WidgetType } from './../../_enums/widgetType.enum';
import { WidgetInfo } from './../../_model/common/widget-info.model';
import { CommonService } from './../../_services/common.service';
import { BaseStateActions } from './../../_state/base/base.actions';
import { WidCommonService } from './services/wid-common.service';

@Component({
    selector: 'app-widget',
    templateUrl: './widget.component.html',
    styleUrls: ['./widget.component.scss'],
})
export class WidgetComponent implements OnInit {
    private wkey: string;
    private ckey: string;
    private sckey: string;
    private skey: string;
    private bskey: string;
    private onDestroy$ = new Subject<void>();

    constructor(
        private activeRoute: ActivatedRoute,
        private rest: WidCommonService,
        private store: Store,
        private router: Router,
        private commonRest: CommonService,
    ) {}

    ngOnInit() {
        this.activeRoute.params.pipe(takeUntil(this.onDestroy$)).subscribe(params => {
            this.wkey = params['wkey'];
            this.ckey = params['ckey']; //contractor
            this.sckey = params['sckey']; //subcontractor
            this.skey = params['skey']; //service
            this.bskey = params['bskey']; //bs
            if (this.wkey) {
                this.rest
                    .getWidgetData(this.wkey)
                    .pipe(
                        mergeMap((widgetInfo: WidgetInfo) => {
                            if (this.ckey && this.skey) {
                                //ce je dinamicni modul oz. da pridejo parametri od zuanj - niso nastavljeni na samem widgetu
                                return this.commonRest.getService(this.ckey, this.skey, this.bskey != undefined).pipe(
                                    map(service => {
                                        widgetInfo.maskedContractorId = this.ckey;
                                        widgetInfo.maskedSubcontractorId = this.sckey == 'undefined' ? undefined : this.sckey;
                                        widgetInfo.maskedServiceId = this.skey;
                                        widgetInfo.serviceName = service.name;
                                        if (this.bskey) {
                                            widgetInfo.maskedBsId = this.bskey;
                                            widgetInfo.externalServices = [];
                                            widgetInfo.externalServices.push({
                                                externalMaskedId: this.skey,
                                                name: service.name ? service.name : 'NO NAME',
                                                directBooking: service?.directBooking,
                                            });
                                            widgetInfo.isExternal = true;
                                        }
                                        return widgetInfo;
                                    }),
                                );
                            }
                            return of(widgetInfo);
                        }),
                    )
                    .subscribe((widgetInfo: WidgetInfo) => {
                        this.store.dispatch(new BaseStateActions.Widget.Init(widgetInfo)).subscribe(() => {
                            switch (widgetInfo.widgetType) {
                                case WidgetType.SELF_BOOKING:
                                    this.store
                                        .dispatch([
                                            new BaseStateActions.Common.GetContractor(),
                                            // new BaseStateActions.Widget.GetWidgetData(), //TODO
                                        ])
                                        .subscribe(() => {
                                            if (widgetInfo?.data?.companyDetails) {
                                                //prikaži input polja za podjetja
                                                this.router.navigate(['/public/booking-widget/company-info'], {
                                                    queryParamsHandling: 'merge',
                                                    replaceUrl: true,
                                                });
                                            } else {
                                                if (
                                                    (widgetInfo?.externalServices?.length != undefined &&
                                                        widgetInfo?.externalServices?.length > 0 &&
                                                        widgetInfo?.externalServices[0]?.directBooking) ||
                                                    !widgetInfo.isExternal
                                                ) {
                                                    this.router.navigate(['/public/booking-widget/term'], {
                                                        queryParams: { wid: this.wkey },
                                                        queryParamsHandling: 'merge',
                                                        replaceUrl: true,
                                                    });
                                                } else {
                                                    //čv
                                                    this.router.navigate(['/public/booking-widget/waiting-queue'], {
                                                        queryParams: { wid: this.wkey },
                                                        queryParamsHandling: 'merge',
                                                        replaceUrl: true,
                                                    });
                                                }
                                            }
                                        });
                                    break;
                                case WidgetType.INQUIRY:
                                    this.store.dispatch(new BaseStateActions.Common.GetContractor()).subscribe(() => {
                                        this.router.navigate(['/public/inquiries-widget'], {
                                            queryParams: { wid: this.wkey },
                                            queryParamsHandling: 'merge',
                                            replaceUrl: true,
                                        });
                                    });

                                    break;
                                case WidgetType.CONTRACTOR_RATING:
                                    this.router.navigate(['/public/contractor-rating'], {
                                        queryParams: { wid: this.wkey },
                                        queryParamsHandling: 'merge',
                                        replaceUrl: true,
                                    });
                                    break;
                                case WidgetType.ADVANCED_SELF_BOOKING:
                                    this.store.dispatch(new BaseStateActions.Common.GetContractor()).subscribe(() => {
                                        this.router.navigate(['/public/booking-widget/service'], {
                                            queryParams: { wid: this.wkey },
                                            queryParamsHandling: 'merge',
                                            replaceUrl: true,
                                        });
                                    });
                                    break;
                                default:
                                    break;
                            }
                        });
                    });
            }
        });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
    }
}
